import React from "react";
import ForumIcon from "@mui/icons-material/Forum";

import { useNavigate } from "react-router-dom";
import CustomBtn from "./ButtonTemplate";

interface MsgBtnProps {
  userId: string;
  tip?: string;
  receiverName?: string;
}

function MsgBtn({ userId, tip = "Message User", receiverName = "Unknown" }: MsgBtnProps) {
  const navigate = useNavigate();
  return (
    <CustomBtn
      action={() => {
        navigate(`/conversation/${userId}`, {
          state: { receiverName },
        });
      }}
      type="warning"
      icon={<ForumIcon />}
      tip={tip}
    />
  );
}


export default MsgBtn;
